import { Button } from "@mui/material";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";

export default function SectionHeaderActions({ onExport }) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<UploadOutlinedIcon />}
      sx={{ borderRadius: 20, textTransform: "none", fontSize: 13, color: "black", border: "1px solid lightgray", fontWeight: 600 }}
      onClick={onExport}
    >
      Export
    </Button>
  );
}
